export const META_BUSINESS_SUITE_PHONE_URL =
  "https://business.facebook.com/latest/whatsapp_manager/phone_numbers";

export function normalizeQualityRating(rating) {
  if (!rating) return null;
  const normalized = String(rating).trim().toUpperCase();
  if (normalized === "GREEN" || normalized === "YELLOW" || normalized === "RED") {
    return normalized;
  }
  return null;
}

export function getQualityIndicatorType(rating) {
  const normalized = normalizeQualityRating(rating);
  if (normalized === "RED") return "Danger";
  if (normalized === "YELLOW") return "Warning";
  if (normalized === "GREEN") return "Success";
  return null;
}
